import { render } from "./CommonLayouts.vue?vue&type=template&id=f0fd2f8a&scoped=true"
import script from "./CommonLayouts.vue?vue&type=script&lang=js"
export * from "./CommonLayouts.vue?vue&type=script&lang=js"

import "./CommonLayouts.vue?vue&type=style&index=0&id=f0fd2f8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0fd2f8a"

export default script